import React from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { GridColumnHeaderParams } from "@mui/x-data-grid";
import { useStore } from "../../../store";
import { DataGrid } from "../../../components";
import moment from "moment";
import { useCookies } from "react-cookie";

const Table = () => {
  const {
    AIReviewStore: {
      gridOption: {
        columns,
        rows,
        totalCount,
        loading,
        page,
        rowsPerPage,
        sort,
        columnGroupingModel,
      },
      setRows,
      setGridOption,
      setSortKey,
      sortKey,
      onPageSizeChange,
      onPageChange,
    },
  } = useStore();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();

  const SORTABLE_FIELDS = [
    "createdAt",
    "videoQualityScore",
    "videoEditingScore",
    "totalScore",
  ];

  const headerClickEvent = (item: GridColumnHeaderParams) => {
    if (!SORTABLE_FIELDS.includes(item.field)) return;

    let nextKey = item.field;
    let nextDir: "asc" | "desc";

    if (sortKey === item.field) {
      nextDir = sort === "desc" ? "asc" : "desc";
    } else {
      nextDir = "desc";
    }

    setSortKey(nextKey);
    setCookie("ai_sortKey", nextKey, { path: "/", expires });
    setCookie("ai_tSort", nextDir, { path: "/", expires });
    setGridOption({ page: 0, sort: nextDir });
    setRows();
  };

  const onColumnVisibilityChange = (params: any) => {
    const savedHiddenColumns = localStorage.getItem("ai_columns");
    if (savedHiddenColumns !== null) {
      const arr = JSON.parse(savedHiddenColumns);
      let result = arr;
      if (params.isVisible) {
        result = result.filter((el: any) => el !== params.field);
      } else {
        result.push(params.field);
      }
      localStorage.setItem("ai_columns", JSON.stringify(result));
    } else {
      localStorage.setItem("ai_columns", JSON.stringify([`${params.field}`]));
    }
  };

  const handleCellClick = (params: any, event: any) => {
    event.preventDefault();
    navigate(`/templates/${params.row.templateId}`);
  };

  const getRowClassName = (params: any) => {
    if (params.row.reviewStatus === "Rejected") {
      return "is-rejected";
    } else if (params.row.reviewStatus === "Published") {
      return "is-published";
    } else if (params.row.reviewer !== "") {
      return "is-reviewer";
    } else {
      return "";
    }
  };

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      totalCount={totalCount}
      loading={loading}
      page={page}
      rowHeight={52}
      rowsPerPage={rowsPerPage}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      handleColumnHeaderClick={headerClickEvent}
      onCellClick={handleCellClick}
      getRowClassName={getRowClassName}
      onColumnVisibilityChange={onColumnVisibilityChange}
      columnGroupingModel={columnGroupingModel}
    />
  );
};

export default observer(Table);
